import { getExamTimerSeconds } from './examTimerDuration';
import { UCAT_SUBTEST_KEYS, UCAT_SUBTEST_LABELS } from './ucatSubtests';
import { getTopicDrillDurationMinutes } from './getTopicDrillDurationMinutes';
import { getUcatModuleDurationMinutes } from './getUcatModuleDurationMinutes';

function extraTimeLabel(minutes) {
  const total = getExamTimerSeconds(minutes, 'timed_extra');
  if (!Number.isFinite(total) || total <= 0) return null;
  const m = Math.floor(total / 60);
  const s = total % 60;
  return s > 0 ? `${m} minutes ${s} seconds` : `${m} minutes`;
}

const SUBTEST_ROWS = [
  { name: 'Verbal Reasoning', questions: '44', ucat: '22 minutes', extra: '27 minutes 30 seconds' },
  { name: 'Decision Making', questions: '35', ucat: '37 minutes', extra: '46 minutes 15 seconds' },
  { name: 'Quantitative Reasoning', questions: '36', ucat: '26 minutes', extra: '32 minutes 30 seconds' },
  { name: 'Situational Judgement', questions: '69', ucat: '26 minutes', extra: '32 minutes 30 seconds' },
];

function rowFromModule(mod, fallback) {
  const key = mod?.moduleKey;
  const count = Array.isArray(mod?.questions) && mod.questions.length
    ? String(mod.questions.length)
    : fallback.questions;
  const slotMinutes = Number(mod?.durationMinutes);
  const minutes = Number.isFinite(slotMinutes) && slotMinutes > 0
    ? slotMinutes
    : getTopicDrillDurationMinutes({
      exam: 'UCAT',
      moduleKey: key,
      examConfig: mod?.exam_config,
    }) || getUcatModuleDurationMinutes(mod || { moduleKey: key });
  return {
    name: UCAT_SUBTEST_LABELS[key] || fallback.name,
    questions: count,
    ucat: `${minutes} minutes`,
    extra: extraTimeLabel(minutes) || fallback.extra,
  };
}

export function ucatTopicOverviewRows(pearsonModules) {
  if (Array.isArray(pearsonModules) && pearsonModules.length === 4) {
    return UCAT_SUBTEST_KEYS.map((key, idx) => {
      const mod = pearsonModules.find((m) => m?.moduleKey === key) || pearsonModules[idx];
      const fallback = SUBTEST_ROWS[idx];
      const minutes = getUcatModuleDurationMinutes(mod || { moduleKey: key });
      const count = Array.isArray(mod?.questions) && mod.questions.length
        ? String(mod.questions.length)
        : fallback.questions;
      return {
        name: UCAT_SUBTEST_LABELS[key] || fallback.name,
        questions: count,
        ucat: `${minutes} minutes`,
        extra: extraTimeLabel(minutes) || fallback.extra,
      };
    });
  }
  if (Array.isArray(pearsonModules) && pearsonModules.length >= 1) {
    return pearsonModules.map((mod, idx) => {
      const fallback = SUBTEST_ROWS[idx] || SUBTEST_ROWS[0];
      return rowFromModule(mod, fallback);
    });
  }
  return SUBTEST_ROWS;
}

export function ucatSubtestsOverviewCopy(pearsonModules) {
  const n = Array.isArray(pearsonModules) ? pearsonModules.length : 0;
  if (n === 4) {
    return {
      leadIn: 'You have 2 minutes to read this screen.',
      consistsOf: 'This exam consists of four subtests:',
      durationSeconds: 120,
    };
  }
  const name = n === 1
    ? (UCAT_SUBTEST_LABELS[pearsonModules[0]?.moduleKey] || 'this subtest')
    : 'this subtest';
  return {
    leadIn: 'Read this screen, then click Next to continue.',
    consistsOf: `This practice consists of one subtest: ${name}.`,
    durationSeconds: 60,
  };
}
